import { render } from "./WhyChooseUs.vue?vue&type=template&id=11802c28&scoped=true"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"

import "./WhyChooseUs.vue?vue&type=style&index=0&id=11802c28&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11802c28"]])

export default __exports__